import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/get";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import MSCartesian from '../_internal/mscartesian';
import ColumnDataset from '../../dataset/column';
import ColumnMultiSeriesGroup from '../../dataset/groups/column-multiseries';

var MSColumn2D =
/*#__PURE__*/
function (_MSCartesian) {
  _inherits(MSColumn2D, _MSCartesian);

  _createClass(MSColumn2D, [{
    key: "getName",
    value: function getName() {
      return 'MSColumn2D';
    }
  }], [{
    key: "getName",
    value: function getName() {
      return 'MSColumn2D';
    }
  }]);

  function MSColumn2D() {
    var _this;

    _classCallCheck(this, MSColumn2D);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MSColumn2D).call(this)), _this.eiMethods = {};
    return _this;
  }

  _createClass(MSColumn2D, [{
    key: "__setDefaultConfig",
    value: function __setDefaultConfig() {
      _get(_getPrototypeOf(MSColumn2D.prototype), "__setDefaultConfig", this).call(this), this.config.friendlyName = 'Multi-series Column Chart', this.config.defaultDatasetType = 'column', this.config.enablemousetracking = !0;
    }
  }, {
    key: "getDSdef",
    value: function getDSdef() {
      return ColumnDataset;
    }
  }, {
    key: "getDSGroupdef",
    value: function getDSGroupdef() {
      return ColumnMultiSeriesGroup;
    }
  }]);

  return MSColumn2D;
}(MSCartesian);

export default MSColumn2D;